import { onMounted, reactive } from '@vue/composition-api'

const useMasonry = (nbCols = 3) => {
  const masonry = reactive({
      items: [],
      columns: [],
      nbTreatedItems: 0,
    });

  // =>  METHODS
  const initColumns = () => {
    for (let i = 0; i < nbCols; i++) {
      masonry.columns.push({ items: [], height: 0 });
    }
  };

  const resetMasonry = () => {
    masonry.columns = [];
    masonry.nbTreatedItems = 0;
    masonry.items = [];

    initColumns();
  };

  const loadMasonryItems = (items) => {
    masonry.items = masonry.items.concat(items);

    addItemToShortestMasonryColumn();
  };

  const addItemToShortestMasonryColumn = () => {
    if (masonry.nbTreatedItems >= masonry.items.length) {
      return;
    }

    const item = masonry.items[masonry.nbTreatedItems];

    const shortestColumnIndex = masonry.columns.reduce(
      (minIndex, column, index) =>
        column.height < masonry.columns[minIndex].height ? index : minIndex,
      0
    );
    
    masonry.columns[shortestColumnIndex].items.push(item);

    masonry.nbTreatedItems += 1;
  };

  const updateMasonryColumnHeight = (columnIndex, cardHeight) => {
    masonry.columns[columnIndex].height += cardHeight;
    addItemToShortestMasonryColumn();
  };

  // =>  COMPUTED

  // =>  WATCH

  // =>  HOOKS
  onMounted(() => {
    initColumns();
  });

  // =>  DATA
  return { loadMasonryItems, masonryState: masonry, resetMasonry, updateMasonryColumnHeight };
};

export default useMasonry;
